import { Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { converToDayjs } from '_constants';
import { StyledDetailDescription, StyledFormLabel } from 'components/atoms';
import dayjs, { Dayjs } from 'dayjs';
import React, { useMemo, useState } from 'react';

import { GoalNotesDisplayProps } from './types';

export const GoalNotesDisplay = ({ notes }: GoalNotesDisplayProps) => {
  const [startDate, setStartDate] = useState<Dayjs | null>(
    converToDayjs(dayjs().startOf('month').format('MM-DD-YYYY')),
  );
  const [endDate, setEndDate] = useState<Dayjs | null>(
    converToDayjs(dayjs().endOf('month').format('MM-DD-YYYY')),
  );

  const filteredNotes = useMemo(() => {
    if (!startDate || !endDate) return notes;
    return notes.filter((note) => {
      const noteDate = dayjs(note.timestamp);
      return noteDate.isAfter(startDate) && noteDate.isBefore(endDate.add(1, 'day'));
    });
  }, [notes, startDate, endDate]);

  return (
    <Box>
      <StyledDetailDescription sx={{ marginTop: 10 }}>
        Select Date Range For Notes
      </StyledDetailDescription>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 20,
          marginTop: 10,
          width: '50%',
        }}
      >
        <DatePicker label="Start Date" value={startDate} onChange={setStartDate} />
        <DatePicker label="End Date" value={endDate} onChange={setEndDate} />
      </Box>
      {filteredNotes.map((note, index) => (
        <Box
          key={`goal-note-${note.id}`}
          sx={{
            borderBottom: index !== notes.length - 1 ? '1px solid #ccc' : 'none',
            paddingBottom: '16px',
            marginBottom: '16px',
          }}
        >
          <StyledFormLabel sx={{ marginTop: '8px' }}>
            {dayjs(note.timestamp).format('MM/DD/YYYY')}
          </StyledFormLabel>
          <StyledFormLabel>PROGRESS STATUS</StyledFormLabel>
          <Typography sx={{ marginBottom: '8px', marginLeft: '0.25rem' }}>
            {note.rating}
          </Typography>
          <StyledFormLabel sx={{ marginTop: '8px' }}>NOTES</StyledFormLabel>
          <Typography sx={{ marginLeft: '0.25rem' }}>{note.notes}</Typography>
        </Box>
      ))}
    </Box>
  );
};
